import React from 'react';


export default class Avatar extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (

			<img src="https://pic4.zhimg.com/68427b7eeaf29a3a47205148f2286173_l.png" alt="avatar"/>

		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/content/avatar.js
 **/